import React from 'react';
import './ButonInstallAppNav.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const ButonInstallAppNav = () => {
    const handleRedirectPortada = () => {
        // Redireccionar a la portada principal pública
        window.location.href = '/';
    };

    return (
        <button
            type="button"
            onClick={handleRedirectPortada}
            className="btnEyePortada"
            title="Ver portada pública (sitio web)"
            aria-label="Ver portada pública"
        >
            <FontAwesomeIcon icon={faEye} />
        </button>
    );
};

export default ButonInstallAppNav;